import Page from "webPage/Page";

Page.register(['blog', 'category', 'search'], () => {
    $('body').on('click', '.js-open-filters', function () {
        $('body').addClass('show-filters');
        return false;
    }).on('click', '.js-close-filters', function () {
        $('body').removeClass('show-filters');
    });
});